export default __webpack_public_path__ + "static/media/resource1.759f3d5f.png";